import { actions } from '../../utils/constants';

export const changeSuccessAddTemplateTest = ({ success }) => ({
    type: actions.CHANGE_SUCCESS_ADD_TEMPLATE_TEST,
    payload: success,
});

export const asyncAddTemplateTest = ({
    labelTest,
    typeTest,
    maxDuration,
    minOptions,
    maxOptions,
    percentual,
    createNewTest,
    questions,
    amountQuestions,
}) => ({
    type: actions.ASYNC_ADD_TEMPLATE_TEST,
    payload: {
        labelTest,
        typeTest,
        maxDuration,
        minOptions,
        maxOptions,
        percentual,
        createNewTest,
        questions,
        amountQuestions,
    },
});



// WEBPACK FOOTER //
// ./src/components/add-template-test/add-template-test.actions.js